import { useIsAdminViewer } from '../../lib/menu-catalog';
import { HrHomePage } from './HrHomePage';
import { MyHrHomePage } from './MyHrHomePage';

/**
 * 인사 착지 화면 — 같은 주소(`/erp/hr`)가 **보는 사람에 따라** 갈라진다.
 *
 * 회사 관리자는 «인사 현황»(재직 인원·연차 소진율·손봐야 할 것), 직원은 «내 인사»
 * (오늘 출퇴근·내 연차·내 신청). 메뉴를 둘로 쪼개지 않는 이유는 시안과 같다 —
 * 직원에게도 이 메뉴의 이름은 «인사» 하나여야 한다.
 *
 * 판정은 `useIsAdminViewer()` — 좌측 레일·즐겨찾기가 쓰는 **같은 함수**다(보이기 규칙 한 곳).
 */
export function HrIndex() {
  return useIsAdminViewer() ? <HrHomePage /> : <MyHrHomePage />;
}
